export const loginImages = {
  remmi_logo: 'assets/headerLogin/Remmi_Logo.svg',
  eye_closed: 'assets/headerLogin/eye-closed.svg',
  login_right: 'assets/headerLogin/login@3x.png',
  site_logo: 'assets/new-img/site-logo/Remmi_Logo.svg',
  linkedIn_logo: 'assets/new-img/site-logo/linkedin.svg',
  facebook_logo: 'assets/new-img/site-logo/facebook.svg',
  instagram_logo: 'assets/new-img/site-logo/insta.svg',
  copyright: 'assets/new-img/site-logo/Copyright.svg',
  xenex: 'assets/new-img/site-logo/xenex.svg',
};
